import { Component } from '@grafikr/components';
import Modal from "utils/components/modal";
import { isbot } from "isbot";
import { NonNullish } from "../utils/nullish-check";

function urlMatch(pattern: string) {
  const regexPattern = pattern.replace(/\*/g, '.*');
  return window.location.pathname.match(regexPattern);
}

export default Component((node, { onMounted }) => {
  const modal = new Modal(node);

  const urlExcludes = JSON.parse(NonNullish(node.dataset.urlExcludes)) as Array<string>;
  const patternExcludes = JSON.parse(NonNullish(node.dataset.patternExcludes)) as Array<string>;

  const closeTriggers = node.querySelectorAll<HTMLElement>('[data-close]');
  closeTriggers.forEach((button) => {
    button.addEventListener('click', modal.close);
  });

  const openTriggers = document.querySelectorAll<HTMLElement>('[data-geo-trigger]');
  openTriggers.forEach((button) => {
    button.addEventListener('click', modal.open);
  });

  onMounted(() => {
    const GEO_KEY = "puori-geo-dismissed";
    const GEO_EXPIRY = 24 * 60 * 60 * 1000
    const URL_PARAM_SKIP_KEY = 'geo'

    const dismiss = () => {
      localStorage.setItem(GEO_KEY, new Date().getTime().toString());
    }

    const getLocation = async () => {
      const response = await fetch('https://get.geojs.io/v1/ip/geo.json').then(res => res.json());

      const { continent_code: continent, country_code: country } = response;

      let isOnCorrectStore
      switch (Shopify.shop) {
        case 'puori-eu.myshopify.com':
          isOnCorrectStore = !['SA', 'NA'].includes(continent.toUpperCase()) && !['DK', 'GB'].includes(country.toUpperCase())
          break;
        case 'puori-us.myshopify.com':
          isOnCorrectStore = ['SA', 'NA'].includes(continent.toUpperCase())
          break;
        default:
          isOnCorrectStore = country.toUpperCase() === Shopify.country;
          break;
      }

      if (isOnCorrectStore) {
        dismiss();
        return;
      }

      modal.open();
    }

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has(URL_PARAM_SKIP_KEY) || isbot(navigator.userAgent)) {
      dismiss();
      urlParams.delete(URL_PARAM_SKIP_KEY);
      const updatedUrl = `${window.location.pathname}?${urlParams}${
        window.location.hash
      }`;
      window.history.replaceState({}, document.title, updatedUrl);
      return;
    }

    if (localStorage.getItem(GEO_KEY)) {
      const timestamp = parseInt(localStorage.getItem(GEO_KEY)!);
      const now = new Date().getTime();
      if (timestamp && now - timestamp < GEO_EXPIRY) {
        dismiss();
        return;
      }
    }

    if (urlExcludes.some(url => window.location.pathname === url)) {
      return;
    }

    if (patternExcludes.some(url => urlMatch(url))) {
      return;
    }

    getLocation();

    modal.on('close', dismiss);
  });
});
